import {put} from 'redux-saga/effects';
import {errorToast} from '../actions';

export function* errorHandler(error, actionType) {
  yield put({type: actionType, payload: error.message});
  if (error.status !== 400 && error.status !== 409) {
    yield put(errorToast(error.message));
  }
}

export const fieldError = (error, fieldName) => {
  if (Array.isArray(error)) {
    const item = error.find(e => e.name === fieldName);
    if (!!item) {
      return item.message;
    }
  } else if (typeof error === 'object') {
    if (error.hasOwnProperty(fieldName)) {
      return error[fieldName];
    }
  }
  return '';
};

export const isFieldIvalid = (error, fieldName) => {
  if (
    (typeof error === 'string' && error !== '') ||
    !!fieldError(error, fieldName)
  ) {
    return true;
  }
  return false;
};
